
<template>
	<div v-if="dotsLoading" class="mt-2">
		<div class="flex items-center justify-center w-full h-16 skeleton mt-4 tableCornerRadius bg-white">
			<dotsloader />
		</div>
	</div>
	<div v-else class="table-data-root">
		<div class="tableCornerRadius bg-white table-card-shell">
			
		<div :class="pageData!=undefined && pageData == 4 ? 'fixHeightTable flex flex-col justify-between':'table-card-inner'">
			<div class="table-container table-container-fit">
			<div class="table-header-wrap">
			<table class="table-fit-card table-header-table" :style="tableResizeStyle">
				<thead>
					<tr>
					<th
						scope="col"
						v-for="presentColumn in columnNames"
						:key="presentColumn"
						:class="[getColumnHeadWidth(presentColumn), isCenterAlignedColumn(presentColumn) ? 'column-center' : '']"
						class="bg-white capitalize resizable-th"
						:style="columnStyle(presentColumn)"
						@click="onHeaderClick(presentColumn)"
					>
					<div class="flex" :class="getPaddingForColumn(presentColumn)">
						<div>{{ getColumnLabel(presentColumn) }}</div>
						<div v-if="presentColumn == 'framework_controlNo'">
						</div>
						<div class="sort cursor-pointer" :class="className == presentColumn ? classSort : 'opacity-50'" v-else-if="getColumnLabel(presentColumn) != ''"></div>
					</div>
					<span class="column-resize-handle" @mousedown.stop.prevent="startColumnResize($event, presentColumn)"></span>
					</th>
					</tr>
					<tr v-if="visibility">
						<td v-for="(presentColumn, index) in columnNames" :key="index" :class="isCenterAlignedColumn(presentColumn) ? 'column-center' : ''" :style="columnStyle(presentColumn)">
							<!-- Dropdown -->
							<select :class="filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect'" v-if="isColumnArrayPresent(presentColumn)" class="statusFilter"  v-model="filters[presentColumn]">
								<option :value="filters.presentColumn" selected hidden disabled>Select</option>
								<option class="optionColors" v-for="option in getDropdownOptionsForFilter(presentColumn)" :key="option.id" :value="option.id">{{ option.value }}</option>
							</select>
							<select :class="filters[presentColumn] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling'" v-model="filters[presentColumn]" v-if="presentColumn=='criticality'" >
                                <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                                <option class="optionColors" v-for="pair in dbProcessCriticality" :key="pair" :value="pair.value">{{ pair.key }}</option>
                                <!-- <option class="optionColors" v-for="value in getCriticalityOptions()" :key="value.id" :value="value.id">{{ value.value }}</option> -->
                            </select>
							<select :class="filters[presentColumn] == null ? 'inputboxstylingForSelect criticalitystyling' : 'stylingForInputboxstylingForSelect criticalitystyling'" v-model="filters[presentColumn]" v-if="presentColumn=='tier'" >
                                <option :value="filters.presentColumn" selected hidden disabled>Select</option>
                                <option class="optionColors" v-for="pair in entityOptions" :key="pair" :value="pair.label">{{ pair.label }}</option>
                                <!-- <option class="optionColors" v-for="value in getCriticalityOptions()" :key="value.id" :value="value.id">{{ value.value }}</option> -->
                            </select>
							<!-- No Input -->
							<div v-else-if="isFilterNotNecessary(presentColumn)"></div>
							<div v-else-if="presentColumn == 'taskId'" >
								<input type="text" class="searchForInputBoxStyling marginForIdInFilters" v-model.trim="filters[presentColumn]" placeholder="Search" />
							</div>
							<!-- Text Input -->
							<input v-else-if="presentColumn!='type' && presentColumn!='frequency'&& presentColumn!='taskstatus' && presentColumn!='criticality' && presentColumn!='SubTaskStatus'"  type="text" class="searchForInputBoxStyling" v-model.trim="filters[presentColumn]" placeholder="Search" />
						</td>
					</tr>
				</thead>
			</table>
			</div>
			<div class="table-body-scroll">
			<table class="table-fit-card" :style="tableResizeStyle">
				<tbody v-if="loadData == true && sortedData.length == 0">
					<tr class="cursor-pointer empty rowHeight">
						<td class="relative h-5" :colspan="columnNames.size">
							<div class="flex items-center justify-center w-full h-16 skeleton">
								<dotsloader/>
							</div>
						</td>
					</tr>
				</tbody>

				<tbody :class="pageData!=undefined && pageData == 4 ? 'emptyFixed':''" v-else-if="sortedData.length == 0">
					<tr class="cursor-pointer rowHeight">
						<td class="relative h-10" :colspan="columnNames.size">
							<div class="flex justify-center"><p class="text-xs font-normal">No Records Found</p></div>
						</td>
					</tr>
				</tbody>
				
				<tbody class="nonEmptyTable" v-else>
					<tr v-for="(row, index) in sortedData" :key="row" class="cursor-pointer rowHeight" >
						<td v-for="presentColumn in columnNames" :key="presentColumn" @mouseout="doFalse()"  @click="clickedOnTableRowData(row, index, presentColumn)" class="cursor-pointer relative" :class="[getColumnHeadWidth(presentColumn), isCenterAlignedColumn(presentColumn) ? 'column-center' : '']" :style="columnStyle(presentColumn)">
							<!-- <div class=" ml-3 rounded h-5 w-24" v-if="row[presentColumn] == ''">{{ '-' }}</div> -->
							<div v-if="isColumnPresentForLabel(presentColumn)" class="flex justify-center">
								<div class="flex items-center justify-center rounded w-24 h-5 " :class="bgColorForStatus(row[presentColumn])">
									<div :class="textColorForTemplateStatus(row[presentColumn])">
										<!-- {{ row[presentColumn]}} -->
										{{getStatusLabelFromColumn(row[presentColumn],presentColumn)}}
									</div>
								</div>
							</div>
							<!-- framework_controlNo -->
							<div v-else-if="presentColumn=='framework_controlNo'">
								<div style="white-space: break-spaces" v-if="row[presentColumn] != undefined && row[presentColumn].length == 0">{{'N/A  N/A'}}</div>
								<div v-else v-for="(obj,index) in row[presentColumn]" :key="index"  class="flex py-1">
									<div v-if="(obj.framework == undefined || obj.framework == null) && index<1" class="mr-2">{{ 'N/A' }}</div>
									<div v-else class="mr-2">{{ obj.framework }}</div>
									<div v-if="(obj.controls == undefined || (obj.controls.length == 1 && obj.controls[0]==null)) && index<1">{{ 'N/A' }}</div>
									<div v-else>
										<div v-for="control in obj.controls" :key="control" class="flex flex-wrap items-center pb-1" >
											<div :class="getBorder()" class="text-xs px-2 py-0.5 bg-white font-bold h-auto flex items-center" >
												{{ control }}
											</div>
										</div>
										
									</div>
									
								</div>
							</div>
							<div v-else-if="presentColumn == 'criticality'" class="flex justify-center">
                                    <div v-if="row[presentColumn]" class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular" :class="colorRiskBg(row[presentColumn])">
										<div class="table-ellipsisForValue" style="white-space: break-spaces;" :class="colorRiskText(row[presentColumn])" @mousemove="toolTip(presentColumn, $event, index, row, 'label')">
											{{
                                                dbProcessCriticality.find((l) => {
                                                    return l.value == row[presentColumn];
                                                }).key
                                            }}
										</div>
                                	</div>
                                    <div v-else>
                                        -
                                    </div>
                            </div>
							<!-- <div v-else-if="presentColumn=='controlNo'">
								<div v-if="row[presentColumn] != null" class="h-full w-full flex flex-wrap items-center" >
									<div :class="getBorder()" class="text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto flex items-center" >
										{{ row[presentColumn] }}
									</div>
								</div>
								<div v-else>
									-
								</div>
							</div> -->
							<div v-else-if="presentColumn=='startDate'||presentColumn=='dueDate'">
								<div v-if="row[presentColumn] != undefined || row[presentColumn] !=null">
									{{ changeDateFormat(row[presentColumn]) }}
								</div>
								<div v-else>
									-
								</div>
							</div>
							<!-- <div v-else-if="presentColumn=='team'">
								<div>
									{{getTeamName(row[presentColumn])}}
								</div>
							</div> -->
							<div v-else-if="presentColumn=='tier'">
								<div>
									{{row[presentColumn]}}
								</div>
							</div>
							<div v-else-if="presentColumn=='frequency'">
								<div>
									{{getFrequency(row[presentColumn])}}
								</div>
							</div>
							<!-- <div v-else-if="presentColumn=='status'">
								<div class=" ml-1.5 flex items-center justify-center rounded-sm" :class="colorTemplateText(row[presentColumn])">
									<div :class="colorTemplateBg(row[presentColumn])">
										{{getStatusLabelFromColumn(row[presentColumn],presentColumn)}}
									</div>
								</div>
								{{ 
									statusType.find((status:any)=>{
										return statu.id == row[presentColumn]
									})
								}}
							</div> -->
							
							<div v-else-if="presentColumn=='deleteIcon'">
								<div class="flex items-center h-5" :class="isCenterAlignedColumn(presentColumn) ? 'justify-center' : 'justify-start'">
									<img src="@/assets/deleteIcon.svg" class="h-5 w-5 cursor-pointer" @click="clickedOnDeleteButton(row)"/>
								</div>
							</div>
							<div v-else-if="presentColumn=='type'">
								<div v-if="row[presentColumn] == 20501">Task</div>
								<div v-else-if="row[presentColumn] == 20502">Sub-Task</div>
								<div v-else-if="row[presentColumn] == 20503|| row[presentColumn] == 20504">Task</div>
								<div v-else-if="row[presentColumn] == ''">-</div>
							</div>
							<div v-else-if="presentColumn=='title'">
								<div class="title-wrap" @mousemove="toolTip(presentColumn, $event, index, row, 'text')">
									{{ row[presentColumn] }}
								</div>
							</div>
							<div v-else>
								<div class="table-ellipsis">
									<div  @mousemove="toolTip(presentColumn, $event, index, row, 'text')" :class="presentColumn == 'Templates'?'pl-9':''">
										{{ row[presentColumn] }}
									</div>
								</div>
								
							</div>
						</td>
					</tr>
				</tbody>
			</table>
			</div>
			</div>
			<pagination :dynamicPagination="dynamicPagination" @currentPageUpdate="paginationUpdations" :sortedData="sortedData" :pageData="pageData"></pagination></div>
		</div>
	</div>
</template>
<style scoped>
.inputboxstylingForSelect .optionColors{
   color : black !important;
}
.table-ellipsisForValue {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.widthForccid{
	width:120px;
}
.taskStatusStyle{
	width: 120px;
	justify-content: center;
}
.widthOfDuedate{
	width:118px;
}
.fixHeightTable{
	height: 353px !important;
}
.fixHeightTable .table-container-fit {
	flex: 1 1 auto;
	min-height: 0;
	max-height: none;
}
.emptyFixed:last-child  {
	border-bottom: 1px solid var(--color-lightgrey);
}
.nonEmptyTable:last-child  {
	border-bottom: 1px solid var(--color-lightgrey);
}
.ellipsis-container {
	text-overflow: ellipsis;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	line-height: 1.5em;
	max-height: 3em;
}
.table-ellipsis {
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
}
.title-wrap {
	white-space: break-spaces;
	overflow-wrap: anywhere;
}
.column-center {
	text-align: center !important;
}
.column-center .table-ellipsis {
	text-align: center;
	-webkit-box-pack: center;
}
.actionButtonStyling {
    left: -18px;
}
.resizable-th {
	position: relative;
}
.column-resize-handle {
	position: absolute;
	top: 0;
	right: 0;
	width: 6px;
	height: 100%;
	cursor: col-resize;
	user-select: none;
	z-index: 2;
}
.table-data-root {
	display: flex;
	flex-direction: column;
	height: 100%;
	min-height: 0;
}
.table-card-shell {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
}
.table-card-inner {
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
}
.table-container-fit {
	width: 100%;
	max-width: 100%;
	display: flex;
	flex-direction: column;
	flex: 1;
	min-height: 0;
	overflow: hidden;
}
.table-header-wrap {
	flex-shrink: 0;
	scrollbar-gutter: stable;
	border-bottom: 1px solid var(--color-lightgrey);
}
.table-body-scroll {
	flex: 1 1 auto;
	min-height: 0;
	overflow-x: hidden;
	overflow-y: auto;
	overscroll-behavior: contain;
	scrollbar-gutter: stable;
	scrollbar-width: thin;
	scrollbar-color: #c4c4c4 transparent;
	background: #ffffff;
}
.table-body-scroll::-webkit-scrollbar {
	width: 6px !important;
}
.table-body-scroll::-webkit-scrollbar-track {
	background: transparent !important;
}
.table-body-scroll::-webkit-scrollbar-thumb {
	background: #c4c4c4 !important;
	border-radius: 4px !important;
}
.table-fit-card {
	width: 100% !important;
	max-width: 100% !important;
	table-layout: fixed;
	border-collapse: collapse;
	border-spacing: 0;
}
.table-header-table {
	width: 100%;
}
.table-header-table thead tr,
.table-header-table thead th {
	border-top: none !important;
}
.table-fit-card th,
.table-fit-card td {
	overflow: hidden;
	box-sizing: border-box;
}
.table-body-scroll .table-fit-card tbody tr {
	border-top: none !important;
}
.table-body-scroll .table-fit-card tbody td {
	border-bottom: 1px solid var(--color-lightgrey);
	background-color: #ffffff;
}
.table-body-scroll .table-fit-card tbody tr:hover td {
	background-color: #f5f5f5;
}
.lastChild:last-child {
    border: 0px;
}
/* .rowHeight{
  height: 40px;
} */
 .actionButtonWidth{
	width : 60px;
 }
 .numberBorder{
    border-top: 1px solid var(--color-lightgrey);
    border-right: 1px solid var(--color-lightgrey);
    border-bottom: 1px solid var(--color-lightgrey);
}
.numberNavy{
    border-left: 2px solid var(--color-primary);
    /* border-width: 2px; */
}
.zIndexingForActionDropDown{
	z-index : 65;
	width : 100px;
	margin-left : -40px;
}
.pendingEvidence{
    background-color: #8600f040;
}
.evidenceUpload{
    background: rgba(21,39,60,0.24);
}
.widthFor1stAudit{
	width: 98px;
    margin-left: -3px;
}
.w-12{
	width: 60px !important;
}
.bgYellow{
	background-color: rgba(255, 153, 0, 0.2);
}
</style>
<style>
body.col-resizing {
	cursor: col-resize !important;
	user-select: none !important;
}
</style>
<script lang="ts">
import { emitter,toast } from '@/main';
// import _ from 'lodash';
import { defineComponent } from 'vue';
import toolTip from '@/components/toolTip.vue';
import pagination from '@/components/pagination.vue';
import dotsloader from './dotsloader.vue';
import { mapGetters } from 'vuex';

export default defineComponent({
	props: ['tableRowData', 'headersData','pageData','loadData'],
	data(): any {
		return {
			tableHead: [],
			tableRow: [],
			searchTableRow: [],
			visibility: false,
			className: '',
			classSort: '',
			currentSort: 'name',
			currentSortDir: 'asc',
			currentPage: '',
			pageSize: '',
			dynamicPagination: '',
			pop: false,
			styling: { left: '', bottom: '' },
			tipText: '',
			tipColumn: '',
			tipIndex: '',
			filters: {},
			columnWidths: {},
			resizingColumn: null,
			resizeStartX: 0,
			resizeStartWidth: 0,
			didResize: false,
			showDropDown: false,
			selectedRowIndex: '',
			optionsUserArray : [],
			teamObject : [],
			locationObject : [],
			showBlock: false,
			statusType: [
				{
					id: 10401,
					value: 'Open'
				},
				{
					id: 10402,
					value: 'In Progress'
				},
				{
					id: 10421,
					value: 'In Review'
				},
				{
					id: 10403,
					value: 'Completed'
				},
				{
					id: 10411,
					value: 'Draft'
				},
			],
			statuses:[],
			optionsValue: [
                {
                    id: 1,
                    value: 'Edit',
                },
                {
                    id: 2,
                    value: 'View',
                },
                {
                    id: 5,
                    value: 'Controls',
                },
				{
					id: 6,
					value: 'Reports',
				}
            ],
			columns: [
                { key: 'auditId', value: 'Audit ID' },
                { key: 'title', value: 'Title' },
				
				{ key: 'taskstatus', value: 'status' },
				{ key: 'teamName', value: 'team' },
				{ key: 'entityName', value: 'entity' },
				{ key: 'entity', value: 'Location' },
				{ key: 'teamName1', value: 'team' },
				{ key: 'businessProcessName', value: 'Name' },
				{ key: 'name', value: 'Owner' },
				{ key: 'department', value: 'Team' },
				{ key: 'SubTaskStatus', value: 'status' },
				{ key: 'ccid', value: 'CCID' },
				{ key: 'framework_controlNo', value: 'Framework & ControlNo' },
				{ key: 'subTasktitle', value: 'Title' },
				{key:'taskId',value:'ID'},
				{ key: 'controlNumber', value: 'Control #' },
				{ key: 'reason', value: 'Reason' },
				{ key: 'lastUpdated', value: 'Last Updated' },
				{ key: 'dueDate', value: 'Due Date' }
            ],
			dropdownOptions:[
				{
                    key: 'SubTaskStatus',
                    value:[
						{
							id: 10411,
							value: 'Draft'
						},
						{
							id: 10401,
							value: 'Open'
						},
						{
							id: 10402,
							value: 'In Progress'
						},
						{
							id: 10421,
							value: 'In Review'
						},
						{
							id: 10403,
							value: 'Completed'
						},
					],
                
				},
				{
                    key: 'parentTaskStatus',
                    value: [
						{
							id: 10401,
							value: 'Open'
						},
						{
							id: 10402,
							value: 'In Progress'
						},
						{
							id: 10421,
							value: 'In Review'
						},
						{
							id: 10403,
							value: 'Completed'
						},
					],
                
				},
				{
                    key: 'taskstatus',
                    value: [
						
						{
							id: 10401,
							value: 'Open'
						},
						{
							id: 10402,
							value: 'In Progress'
						},
						{
							id: 10421,
							value: 'In Review'
						},
						{
							id: 10403,
							value: 'Completed'
						},
						{
							id: 10420,
							value: 'Failed'
						},
						
					]
                
				},
				{
                    key: 'type',
                    value: [
						
						{
							id: 20501,
							value: 'Task'
						},
						{
							id: 20502,
							value: 'Sub-Task'
						},
					]
                
				},
					{
                    key: 'frequency',
                    value: [
						{ value: 'Daily', id: 1 },
						{ value: 'Weekly', id: 2 },
						{ value: 'Monthly', id: 3 },
						{ value: 'Quarterly', id: 4 },
						{ value: 'Semi Annualy', id: 5 },
						{ value: 'Annualy', id: 6 },
						{ value: 'Transactional', id: 7 },
					]
				},
				
			],
			controlFrequency: [
				{ label: 'Daily', id: 1 },
				{ label: 'Weekly', id: 2 },
				{ label: 'Monthly', id: 3 },
				{ label: 'Quarterly', id: 4 },
				{ label: 'Semi Annualy', id: 5 },
				{ label: 'Annualy', id: 6 },
				{ label: 'Transactional', id: 7 },
			],
			// actionButtonRow:{}
			entityOptions:[
				{
					value:10107,
					label:'Activity'
				},
				{
					value:10108,
					label:'System'
				},
				{
					value : 10109,
					label:'Project'
				}
			]
		};
	},
	components: {
		toolTip,
		pagination,
		dotsloader
	},
	computed: {
		sortedData: function (): any {
			return [...this.tableRow]
				.filter((row: any) => {
					for (const key in this.filters) {
						const inputValue = this.filters[key];
						if (inputValue !== '' && row[key]!='') {
							if (Number.isInteger(row[key])) {	
								if(inputValue == 20501 && (row[key]==20501|| row[key]== 20503|| row[key]== 20504)){	
									return true;
								}
								if(row[key]==''){									
								return false;
								}
								if (row[key] !== Number(inputValue)) {									
									return false;
								}
							} else {
								const val = row[key]?.trim().replace(/^"|"$/g, ''); // Remove surrounding quotes if any
								const isEmpty = val === '' || val === 'N/A' || val === null || val === undefined;								
								if(isEmpty==true){									
									return false;
								}								
								else if ( row[key]!=''&& !row[key].toLowerCase().includes(inputValue.toLowerCase())) {
									return false;
								}
							}
						}
					}
					return true;
				})
				.sort((a, b) => {
					let modifier = 1;
					if (this.currentSortDir == 'desc') modifier = -1;
					const aVal = (a[this.currentSort] ?? '').toString();
					const bVal = (b[this.currentSort] ?? '').toString();
					const aNumMatch = aVal.match(/\d+$/);
					const bNumMatch = bVal.match(/\d+$/);
					if (aNumMatch && bNumMatch) {
						const aNum = parseInt(aNumMatch[0], 10);
						const bNum = parseInt(bNumMatch[0], 10);
						if (aNum < bNum) return -1 * modifier;
						if (aNum > bNum) return 1 * modifier;
						return 0;
					}
					if (aVal < bVal) return -1 * modifier;
					if (aVal > bVal) return 1 * modifier;
					return 0;
				})
				.filter((row, index) => {
					this.dynamicPagination = index + 1;
					let start = (this.currentPage - 1) * this.pageSize;
					let end = this.currentPage * this.pageSize;
					if (index >= start && index < end) return true;
				});
		},
		columnNames: function (): any {
            const names = new Set();
            for (const key of this.headersData) {
                if (key != 'entityId' && key != '_id') names.add(key);
            }
            return names;
        },
		// actionKeys: function():any{
		// 	let startArray = [1,3,4,5,6];
		// 	let progressArr = [2,4,5,6];
		// 	let mainArr :any
		// 	if(this.actionButtonRow.auditStatus == 10401){
		// 		mainArr = startArray
		// 	}else{
		// 		mainArr = progressArr;
		// 	}
		// 	return this.optionsValue.filter((obj:any)=>{return mainArr.includes(obj.id)})
		// }
		...mapGetters({ dotsLoading: 'dotsLoading',
			 userInfo: 'userInfo',
			 dbPriority: 'dbPriority',
			 dbProcessCriticality:'dbProcessCriticality',
			 dbFrequency:'dbFrequency'
			 }),
		tableResizeStyle(): any {
			return {
				tableLayout: 'fixed',
				width: '100%',
				maxWidth: '100%',
			};
		},
	},
	async mounted() {
		this.initialize();
		emitter.on('visible', (isBoolean: any) => {
			this.visibility = isBoolean;
			this.visibility == false ? this.filters = {}:'';
		});
		emitter.on('*', (type, booleanValue) => {
        	if (type == 'apps-sidemenubar' || type == 'toggle-sidebar') {
        		this.showDropDown == true ? (this.showDropDown = false) : '';
        	} else {
        		if (this.showBlock === true) {
        			this.showDropDown == true ? (this.showDropDown = booleanValue) : '';
        		} else if (this.showBlock === false) {
        			this.showDropDown == true ? '' : (this.showDropDown = booleanValue);
        			this.showBlock = true;
        		}
        	}
        });
		window.addEventListener('resize', this.clampWidthsToContainer);
	},
	beforeUnmount() {
		this.stopColumnResize();
		window.removeEventListener('resize', this.clampWidthsToContainer);
	},
	watch: {
		visibility(newValue) {
			if (newValue == false) {
				this.initialize();
			}
		},
		tableRowData: {
			handler(newVal, oldVal) {
				this.tableRow = this.tableRowData;
				this.initialize();
			},
			deep: true
		}
	},
	methods: {
		columnStyle(column: any) {
			const width = this.columnWidths[column];
			if (!width) {
				return {};
			}
			return {
				width: width + 'px',
				minWidth: '60px',
				maxWidth: width + 'px',
			};
		},
		snapshotColumnWidths() {
			const headers = this.$el?.querySelectorAll?.('thead th') || [];
			const names = Array.from(this.columnNames || []) as string[];
			headers.forEach((th: HTMLElement, index: number) => {
				const column = names[index];
				if (column && this.columnWidths[column] == null) {
					this.columnWidths[column] = Math.round(th.getBoundingClientRect().width);
				}
			});
		},
		getContainerWidth() {
			const container = this.$el?.querySelector?.('.table-container') as HTMLElement | null;
			if (container) {
				return Math.max(60, Math.floor(container.clientWidth || container.getBoundingClientRect().width));
			}
			return window.innerWidth;
		},
		maxWidthForColumn(column: string, proposedWidth: number) {
			const names = Array.from(this.columnNames || []) as string[];
			const otherWidth = names.reduce((sum: number, name: string) => {
				if (name === column) {
					return sum;
				}
				return sum + (Number(this.columnWidths[name]) || 60);
			}, 0);
			const containerWidth = this.getContainerWidth();
			const maxTotal = Math.max(60, containerWidth - otherWidth);
			return Math.min(proposedWidth, maxTotal, containerWidth);
		},
		clampWidthsToContainer() {
			const names = Array.from(this.columnNames || []) as string[];
			if (!names.length || !Object.keys(this.columnWidths || {}).length) {
				return;
			}
			const containerWidth = this.getContainerWidth();
			const total = names.reduce((sum: number, name: string) => sum + (Number(this.columnWidths[name]) || 0), 0);
			if (total <= containerWidth) {
				return;
			}
			const scale = containerWidth / total;
			const next: Record<string, number> = { ...this.columnWidths };
			names.forEach((name: string) => {
				if (next[name]) {
					next[name] = Math.max(60, Math.round(next[name] * scale));
				}
			});
			let scaledTotal = names.reduce((sum: number, name: string) => sum + (Number(next[name]) || 0), 0);
			let overflow = scaledTotal - containerWidth;
			for (let i = names.length - 1; i >= 0 && overflow > 0; i--) {
				const name = names[i];
				const current = Number(next[name]) || 0;
				if (current > 60) {
					const reduced = Math.max(60, current - overflow);
					overflow -= current - reduced;
					next[name] = reduced;
				}
			}
			this.columnWidths = next;
		},
		startColumnResize(event: MouseEvent, column: any) {
			this.snapshotColumnWidths();
			this.clampWidthsToContainer();
			const th = (event.currentTarget as HTMLElement)?.closest('th');
			this.resizingColumn = column;
			this.resizeStartX = event.clientX;
			this.resizeStartWidth = this.columnWidths[column] || th?.getBoundingClientRect().width || 60;
			this.didResize = false;
			document.body.classList.add('col-resizing');
			document.addEventListener('mousemove', this.onColumnResize);
			document.addEventListener('mouseup', this.stopColumnResize);
		},
		onColumnResize(event: MouseEvent) {
			if (!this.resizingColumn) {
				return;
			}
			const delta = event.clientX - this.resizeStartX;
			if (Math.abs(delta) > 2) {
				this.didResize = true;
			}
			const nextWidth = this.maxWidthForColumn(
				this.resizingColumn,
				Math.max(60, Math.round(this.resizeStartWidth + delta))
			);
			this.columnWidths = { ...this.columnWidths, [this.resizingColumn]: nextWidth };
		},
		stopColumnResize() {
			this.resizingColumn = null;
			document.body.classList.remove('col-resizing');
			document.removeEventListener('mousemove', this.onColumnResize);
			document.removeEventListener('mouseup', this.stopColumnResize);
		},
		onHeaderClick(column: any) {
			if (this.didResize) {
				this.didResize = false;
				return;
			}
			this.sort(column);
		},
		changeDateFormat(date: any) {
			if (!date || date === 'N/A') {
				return date;
			}
			const value = String(date);
			if (value.includes('T')) {
				const parsed = new Date(value);
				if (!isNaN(parsed.getTime())) {
					const dd = String(parsed.getDate()).padStart(2, '0');
					const mm = String(parsed.getMonth() + 1).padStart(2, '0');
					const yyyy = parsed.getFullYear();
					return `${dd}-${mm}-${yyyy}`;
				}
				return value;
			}
			if (/[A-Za-z]/.test(value)) {
				return value;
			}
			if (value.includes('-')) {
				let dateParts = value.split('-');
				if (dateParts.length === 6) {
				let startDate = `${dateParts[2]}/${dateParts[1]}/${dateParts[0]}`;
				let endDate = `${dateParts[5]}/${dateParts[4]}/${dateParts[3]}`;
				return `${startDate} - ${endDate}`;
				} else if (dateParts.length === 3) {
				return `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
				}
			}
			return value.split('-').reverse().join('/');
		},
		getTierName(col:any){
			if(col!=undefined){
				let tierValue = this.entityOptions.find((tier:any)=>tier.value==col);
				return tierValue && tierValue!=undefined?tierValue.label:'N/A'
			}
			else{
				return 'N/A'
			}
		},
		getLabelDefinationName(value:any){
            let obj =  this.dbProcessCriticality.find((l:any) => { return l.value == value; });
            if(obj!=undefined){
                return obj.key
            }else{
                return '-'
            }
        },
		getFrequency(data:any){
			let d = this.dbFrequency.find((obj:any)=>obj.value == data);
			if(d!=undefined){
				return d.key
			}
			else{
				return 'N/A'
			}

		},
		getBorder(){
            return `numberBorder numberNavy`
        },
		getPaddingForColumn(column:any){
			if (this.isCenterAlignedColumn(column) || column=='SubTaskStatus') {
				return 'justify-center';
			}
        },
		isCenterAlignedColumn(column: any) {
			return column !== 'taskId' && column !== 'title' && column !== 'businessProcessName';
		},
		clickedOnDeleteButton(rowData:any){
            emitter.emit('deleteRowFromTable',rowData)
        },
		colorTemplateText(status: any) {
			if (status == 10411) {
				return ['font-semibold text-disabledgrey'];
			} else if (status == 10415 || status==10421) {
				return ['font-semibold text-yellow'];
			} else if (status == 10403) {
				return ['font-semibold text-lightgreen'];
			} else if(status == 10402){
				return ['font-semibold mx-2 text-electricGreen']
			} else if(status == 10401){
				return ['font-semibold mx-2 text-dakred']
			} else{
				return '-'
			}
		},
		colorTemplateBg(status: any) {
			if (status == 10411) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415 || status == 10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10401) {
				return ['bg-veryHighcolor border-solid border border-darkred'];
			} 
		},
		textColorForStatus(status: any) {
			if (status == 10403 || status == 10418) {
				return ['font-semibold text-darkred'];
			} else if (status == 10402) {
				return ['font-semibold text-electricGreen'];
			} else if (status == 10401) {
				return ['font-semibold text-lightgreen'];
			} else if(status == 10401){
				return ['font-semibold mx-2 text-dakred']
			}
			 else if(status == 10410){
				return ['font-semibold mx-2 text-darkred']
			}
		},
		bgColorForStatus(status: any) {
			if (status == 10411) {
				return ['bg-lightgrey border-solid border border-disabledgrey'];
			} else if (status == 10415 || status==10421) {
				return ['bg-moderateColor border-solid border border-yellow'];
			} else if (status == 10403 || status == 10423) {
				return ['bg-veryLowColor border-solid border border-lightgreen'];
			} else if (status == 10402) {
				return ['pendingEvidence border-solid border border-electricGreen'];
			} else if (status == 10401) {
				return ['bg-primaryBg border-solid border border-primary'];
			} else if (status == 10420) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			} 
			 else if (status == 10410) {
				return ['bg-veryHighColor border-solid border border-darkred'];
			}
			else if (status == 10418) {
				return ['bg-highColor border-solid border border-error'];
			} 
		},
		textColorForTemplateStatus(status: any) {
			if (status == 10411) {
				return ['font-semibold text-xs text-disabledgrey'];
			} else if (status == 10415 || status==10421) {
				return ['font-semibold text-xs text-yellow'];
			} else if (status == 10403 || status == 10423) {
				return ['font-semibold text-xs text-lightgreen'];
			} else if(status == 10402){
				return ['font-semibold text-xs mx-2 text-electricGreen']
			} else if(status == 10401){
				return ['font-semibold text-xs mx-2 text-primary']
			}  else if(status == 10420){
				return ['font-semibold text-xs mx-2 text-darkred']
			}  else if (status == 10410) {
				return ['font-semibold text-xs mx-2 text-darkred'];
			} else if (status == 10418) {
				return ['font-semibold text-xs text-error'];
			}else{
				return '-'
			}
		},
		colorPriorityBg(value: any) {
            if (value == 1) {
                return ['bg-veryLowColor border-solid border border-lightgreen'];
            } else if (value == 2) {
                return ['bg-lowColor border-solid border border-green'];
            } else if (value == 3) {
                return ['bg-moderateColor border-solid border border-yellow'];
            } else if (value == 4) {
                return ['bg-highColor border-solid border border-error'];
            } else if (value == 5) {
                return ['bg-veryHighColor border-solid border border-darkred'];
            }
        },
        colorPriorityText(value: any) {
            if (value == 1) {
                return ['text-lightgreen font-semibold'];
            } else if (value == 2) {
                return ['text-green font-semibold'];
            } else if (value == 3) {
                return ['text-yellow font-semibold'];
            } else if (value == 4) {
                return ['text-error font-semibold'];
            } else if (value == 5) {
                return ['text-darkred font-semibold'];
            }
        },
		colorRiskBg(value: any) {
            if (value == 1) {
                return ['bg-veryLowColor border-solid border border-lightgreen'];
            } else if (value == 2) {
                return ['bg-lowColor border-solid border border-green'];
            } else if (value == 3) {
                return ['bg-moderateColor border-solid border border-yellow'];
            } else if (value == 4) {
                return ['bg-highColor border-solid border border-error'];
            } else if (value == 5) {
                return ['bg-veryHighColor border-solid border border-darkred'];
            }
        },
        colorRiskText(value: any) {
            if (value == 1) {
                return ['text-lightgreen font-semibold'];
            } else if (value == 2) {
                return ['text-green font-semibold'];
            } else if (value == 3) {
                return ['text-yellow font-semibold'];
            } else if (value == 4) {
                return ['text-error font-semibold'];
            } else if (value == 5) {
                return ['text-darkred font-semibold'];
            }
        },
		isColumnPresentForLabel(column:any){
			if(column=='SubTaskStatus' || column=='taskstatus'){
				return true
			}
		},
		initialize() {
			this.tableRow = this.tableRowData;
			this.searchTableRow = this.tableRowData;
		},
		paginationUpdations(currentPage: any, pageSize: any) {
			this.currentPage = currentPage;
			this.pageSize = pageSize;
		},
		sort(tableHead: any) {
			this.className = tableHead;
			if (tableHead == this.currentSort) {
				this.currentSortDir = this.currentSortDir == 'asc' ? 'desc' : 'asc';
			}
			this.currentSort = tableHead;
			this.classSort = this.currentSortDir == 'asc' ? 'sort_asc' : 'sort_desc';
		},
		openPopup(data: any, index: any) {
			let popupdata = {
				entityData: data,
				indexx: index
			};
			emitter.emit('showData123', popupdata);
		},
		toolTip(column: any, e: any, index: any, row: any, status: any) {			
			let ValueKeys:any = ['impact','likelihood','Preview','priority','infopreview','severity','confValue','intValue','avaiValue','scValue','likeValue','opsValue','orgValue','businessValue','techValue','finValue','legalValue','severitypreview','prioritypreview','infoClassValue','proCValue','securityCategory','criticality']
           if(ValueKeys.includes(column)){
               this.tipText = this.getLabelDefinationName( row[column])
            }else{
               this.tipText = row[column];
            }
			this.tipColumn = column;
			this.tipIndex = index;

			switch (status) {
				case 'text':
					this.handleTextTooltip(e,column);
					break;
				case 'label':
                    let ValueKeys:any = ['impact','likelihood','Preview','priority','infopreview','severity','confValue','intValue','avaiValue','scValue','likeValue','opsValue','orgValue','businessValue','techValue','finValue','legalValue','severitypreview','prioritypreview','infoClassValue','proCValue','securityCategory','criticality']
                      if(ValueKeys.includes(column)){
                         const container = e.currentTarget.closest('.table-ellipsisForValue');
                          if (container && this.isTextOverflowed(container)) {							
                             let obj:any = {
                                tipText : this.tipText
                            }
                            emitter.emit('activiteToolTip',obj)
                          }
                     }
                     break;
				case 'circleButton':
					if (e.offsetX < e.target.offsetWidth && e.offsetY < e.target.offsetHeight) {
						this.pop = true;
						this.styling.left = e.offsetX + e.target.offsetLeft + 13 + 'px';
						this.styling.bottom = -15 + 'px';
					}
			}
		},
		handleTextTooltip(e: any, column :any) {
			const container = e.currentTarget.closest('.table-ellipsis');
			if (container && this.isTextOverflowed(container)) {
				// this.pop = true;
				// this.styling.left = e.offsetX + 38 + 'px';
				// this.styling.bottom = -35 + 'px';
				let obj:any = {
					tipText : this.tipText
				}
				emitter.emit('activiteToolTip',obj)
			}
			else if (column === 'criticality' && container) {
                const textContent = container.textContent?.trim() || '';
                let obj:any;
                if (
                    textContent.length > 12 || this.isTextOverflowed(container)
                ) {
                    if(this.dbProcessCriticality && this.dbProcessCriticality.length>0){
                        for(let i=0;i<this.dbProcessCriticality.length;i++){
                            if(this.tipText == this.dbProcessCriticality[i].value){
                                this.tipText = this.dbProcessCriticality[i].key                    
                                obj= {
                                    tipText: this.tipText
                                };
                            }
                        }
                    }
                    emitter.emit('activiteToolTip', obj);
                }
            }
			//  else {
			// 	this.pop = false;
			// }
		},
		isTextOverflowed(element: any) {
			return element.scrollHeight > element.clientHeight;
		},
		doFalse() {
				emitter.emit('deActiviteToolTip')
		},
		getOwnerType(input: any) {
			let type = this.orgType.find((l: any) => {
				return l.id == input;
			});
			if (type == undefined) {
				return input;
			} else {
				return type.value;
			}
		},
		getColumnLabel(columnName: any) {
			if (columnName == 'actionButton' || columnName == 'deleteIcon' ){
                return '';
            }
            const column = this.columns.find((col: { key: any }) => col.key === columnName);
            return column ? column.value : columnName;
        },
		isColumnArrayPresent(columnName: any) {
            // Returns true if the column name has corresponding dropdown options
            return this.dropdownOptions.some((option: { key: any }) => option.key === columnName);
        },
		getDropdownOptionsForFilter(columnName: any) {
			let option:any;
			if(columnName=='taskstatus'){
					const unique = Array.from(
					new Map(this.statuses.map((item:any) => [item.id, item])).values()
					);
				option = {
					key: columnName,
					value: unique.map((item:any) => ({
						id: item.id,
						value: item.label
					}))
				};				
				return option?option.value: [];
			}
			else{
            	option = this.dropdownOptions.find((option: { key: any }) => option.key === columnName);				
				return option ? option.value : [];
			}
        },
		getStatusLabelFromColumn(columnName: any, type: any) {
            // const option = this.dropdownOptions.find((option: { key: any }) => option.key === type);
			// log
            // let option1 = option.value.find((soption: { id: any }) => soption.id === columnName);
			// if(option1 == undefined || option == undefined ||option == null || option1 == null ){
			// 	option1 = '-'
			// }
            // return option ? option1.value : [];
			let option:any;
			if(type=='taskstatus' || type == 'SubTaskStatus'){
				option = {
					key: columnName,
					value: this.statuses.map((item:any) => ({
						id: item.id,
						value: item.label
					}))
				};				
			}
			else{
            	option = this.dropdownOptions.find((option: { key: any }) => option.key === columnName);				
			}	
			 if (!option || !option.value) {
				return '-';
			}
			const option1 = option.value.find(
				(soption: { id: any }) => soption.id === columnName
			);
			if (!option1) {
				return '-';
			}
			return option1.value;
        },
		isFilterNotNecessary(columnName:any) {
            if(columnName == 'dueDate'|| columnName == 'lastUpdated' || columnName == 'deleteIcon' || columnName == 'startDate' || columnName == 'Templates'|| columnName == 'framework_controlNo')
            {
                return true;
            }
			return false;
        },
		// shouldShowDisabled(columnName:any) {
        //     if(columnName == 'startDate' || columnName == 'endDate' || columnName == 'auditPeriod')
        //     {
        //         return true;
        //     }
            
        //         return false;  
        // },
		getLabelsArrayForColumnInStore(column: any){
			if(column == 'auditStatus'){
				return true
			} else{
				return false
			}
		},
		//  getTeamName(ownerId: any) {
        //     let user = this.teamObject.find((obj: any) => {
        //         return obj.value == ownerId;
        //     });
        //     if (user == undefined) {
        //         let empty = 'N/A';
        //         return empty;
        //     } else {
        //         return user.label;
        //     }
        // },
		 getLocationName(locationId: any) {
			if(locationId == 'Global'){
				return 'Global'
			}
			
            let user = this.locationObject.find((obj: any) => {
                return obj.value == locationId;
            });
            if (user == undefined) {
                let empty = '';
                return empty;
            } else {
                return user.label;
            }
        },
		getOwnerName(userId: any) {
            let user = this.optionsUserArray.find((obj: any) => {
                return obj.value == userId;
            });
            if (user == undefined) {
                let empty = '';
                return empty;
            } else {
                return user.label;
            }
        },
		checkuserData(column: any) {
            if (column == 'team' || column == 'entity') {
                return true;
            }
        },
		clickedOnTableRowData(rowData: any,index:any,column:any) {
			const isTemplateTask = rowData.actionType == 20501;
			const isMonitoredTask = !isTemplateTask && (rowData.categoryType==10107 || rowData.categoryType==10108 || rowData.categoryType==10109);
			if(!isTemplateTask && (rowData.actionType==20502 || rowData.actionType==20503 || rowData.actionType==20504 || isMonitoredTask)){
				emitter.emit('clickedOnSubTaskRowData', rowData);
			} else if(column!='deleteIcon'&& !this.$route.path.includes('/templateDetails')&& !this.$route.path.includes('/archiveTemplates')&&!this.$route.path.includes('/editTemplate')&&!this.$route.path.includes('/createTemplate')) {
				emitter.emit('clickedOnRowData', rowData);
			}
        },
		optionClickedOnAction(actionOption:any,rowData:any){
			let actionObj:any = {
				action: actionOption,
				data:rowData
			}
			if(rowData['auditStatus'] != 10401 && actionOption=='Edit'){
                toast.error('Cannot Edit Audit in this Status', {
                    timeout: 1000,
                    closeOnClick: true,
                    closeButton: 'button',
                    icon: true
                });
            }else if(actionOption == 'Findings'){
				this.$router.push({ name: 'auditFindings', params: { auditId: rowData._id } });
			}else{
                emitter.emit('clickedOnDropDownAction',actionObj)
            }
		},
		async getAllUsers() {
            this.optionsUserArray = [];
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/getAll`).then((result: any) => {
                result.data.map((obj: any) => {
                    let sendObj = {
                        value: obj._id,
                        label: obj.name
                    };
                    this.optionsUserArray.push(sendObj);
                });
            });
        },
		 async getallTeams() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].displayName, value: this.users[i]._id });
            }
        },
		 async getallEntities() {
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityName, value: result[i]._id });
            }
        },
		selectInputStyling(column: any){
			if(column == 'auditStatus' || column == 'findingStatus'){
				return 'widthFor1stAudit'
			}
		},
		getColumnHeadWidth(column: any) {
            if (column == 'processName' || column == 'description') {
                return 'w-80';
            } 
			else if(column == 'target'){
				return 'widthForccid';
			}
			else if(column == 'deleteIcon'||column=='ccid'){
				return 'w-20'
			}
			else if(column=='assignee' ||column=='type' || column=='tier'){
				return 'w-28'
			}
			else if(column == 'dueDate' || column == 'lastUpdated'){
				return 'widthOfDuedate'
			}
			else if( column=='taskId'){
				return 'w-24'
			}
			else if(column == 'startDate'|| column=='CCID'|| column == 'SubTaskStatus'||column == 'team'){
                return 'w-28';
			}
			 else if( column == 'Templates' ) {
				return 'w-36'
			}else if(column == 'taskstatus' ){
				return 'taskStatusStyle'
			} 
			else if(column == 'title'){
				return 'w-80'
			}else if(column == 'framework_controlNo' || column == 'businessProcessName') {
				return 'w-56'
			} else if(column == 'department' || column == 'entity' || column == 'subTasktitle') {
				return 'w-36'
			} else if(column == 'SubTaskStatus'||column == 'criticality'|| column == 'teamName' || column == 'controlNumber' || column == 'name' || column=='frequency'){
                return 'w-32';
            }else {
                return '';
            }
        },
		async getTaskStatuses(){
			let appId='10007';
			let entityId='10117';
			await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {								
                this.statuses = [...result.data.taskStatus,...result.data.riskTaskStatuses]
			});
		}
	},
	async created(){
		await this.getTaskStatuses();
        // await this.getAllUsers();
		// await this.getallTeams();
		// await this.getallEntities();
    },
});
</script>

